import {doc, onSnapshot} from "firebase/firestore";

export function gatherUserTeamIds(user = {}, activeTeamId) {
  const ids = new Set();
  const add = value => {if (typeof value === "string" && value.trim()) ids.add(value.trim());};
  for (const field of [user.teamIds, user.teams, user.memberships]) {
    if (Array.isArray(field)) field.forEach(item => add(typeof item === "string" ? item : item?.id || item?.teamId));
  }
  for (const field of [user.teamsMap, user.memberships]) {
    if (field && typeof field === "object" && !Array.isArray(field)) Object.keys(field).forEach(add);
  }
  add(activeTeamId);
  add(user.teamId);
  add(user.activeTeamId);
  return [...ids];
}

export function subscribeCalendarEvents({db, userId, teamId, onChange, onError}) {
  const lifecycle = {active: true};
  let personal = [];
  let profile = {};
  const teams = new Map(), stops = new Map();
  function emit() {
    if (!lifecycle.active) return;
    const allTeams = [], names = {};
    for (const [id, team] of teams) {
      if (!team) continue;
      names[id] = String(team.name || team.teamName || team.title || team.displayName || team.slug || id).trim();
      allTeams.push(...(Array.isArray(team.events) ? team.events : []).map(event => ({...event, __teamId: id})));
    }
    onChange({events: {personal, team: teams.get(teamId)?.events || [], allTeams}, names, activeTeam: teams.get(teamId) || null, teams: Object.fromEntries(teams), user: profile});
  }
  const stopUser = onSnapshot(doc(db, "users", userId), snapshot => {
    if (!lifecycle.active) return;
    const data = snapshot.data() || {};
    profile = data;
    personal = Array.isArray(data.events) ? data.events : [];
    const wanted = new Set(gatherUserTeamIds(data, teamId));
    for (const [id, stop] of stops) if (!wanted.has(id)) {stop(); stops.delete(id); teams.delete(id);}
    for (const id of wanted) {
      if (stops.has(id)) continue;
      // A callback may arrive after unsubscribe; an entry token isolates it.
      const token = {};
      teams.set(id, null);
      let stop = () => {};
      const unsubscribe = () => stop(); unsubscribe.token = token;
      stops.set(id, unsubscribe);
      stop = onSnapshot(doc(db, "teams", id), teamSnapshot => {
        if (!lifecycle.active || !stops.has(id) || stops.get(id).token !== token) return;
        teams.set(id, teamSnapshot.exists() ? teamSnapshot.data() : null); emit();
      }, error => {
        if (!lifecycle.active || !stops.has(id) || stops.get(id).token !== token) return;
        teams.set(id, null); emit(); onError?.(error);
      });
    }
    emit();
  }, error => {
    if (!lifecycle.active) return;
    personal = []; teams.clear();
    stops.forEach(stop => stop()); stops.clear();
    emit(); onError?.(error);
  });
  return () => {lifecycle.active = false; stopUser(); stops.forEach(stop => stop()); stops.clear();};
}
